function openDropdown(e) {
    e.querySelector(".universal-size-list").classList.toggle("hp-open")
}

function changeSize(e, t) {
    let s = e.previousElementSibling.querySelector(".universal-label");
    s.innerHTML = t.target.dataset.size, s.dataset.title = t.target.dataset.size;
    for (let t of e.children) t.dataset.size != s.dataset.title && t.classList.contains("selected") && t.classList.remove("selected");
    t.target.classList.contains("selected") || t.target.classList.add("selected");
    document.querySelector("#size-property").value = t.target.dataset.size
}

function printSizeGrids(e, t = !1) {
    if (document.querySelector(".hasUniversalMappingsize")) {
        const s = e.querySelector(".hasUniversalMappingsize fieldset.product-form__input");
        let n = t ? t.target.dataset.size : window.product_default_size;
        s.querySelectorAll("label").forEach(((e, t) => {
            const s = e.getAttribute("for"),
                r = e.closest("fieldset").querySelector(`#${s}`).value.split("/").map((e => e.replace(/^(WOMENS|MENS|CM|KIDS)\s+/i, ""))),
                a = r.map((e => {
                    const t = e.split(" ");
                    return t.length >= 2 ? [t[0], t.slice(1).join(" ")] : e
                })),
                i = {};
            switch (a.forEach((e => {
                    if (Array.isArray(e)) {
                        const [t, s] = e;
                        i[t] = s
                    }
                })), n) {
                case "UK":
                    e.innerHTML = `<span>UK</span><span>${i.UK}</span>`;
                    break;
                case "US":
                    e.innerHTML = `<span>US</span><span>${i.US}</span>`;
                    break;
                case "EU":
                    e.innerHTML = `<span>EU</span><span>${i.EURO}</span>`;
                    break;
                default:
                    e.innerHTML = `<span>UK</span><br><span>${i.UK}</span>`
            }
        }));
    }
}
document.addEventListener("click", (function(e) {
    const t = e.target.closest(".universal-dropdown .universal-dropdown-container"),
        s = e.target.closest(".universal-dropdown .universal-dropdown-container ul.universal-size-list"),
        n = e.target.closest('[id^="ProductInfo-"]');
    if (t && openDropdown(t), s && (changeSize(s, e), n && printSizeGrids(n, e)), !e.target.matches(".universal-select") && e.target.closest('[id^="ProductInfo-"]')) {
        const t = e.target.closest('[id^="ProductInfo-"]').querySelector(".universal-size-list");
        t && t.classList.contains("hp-open") && t.classList.remove("hp-open")
    }
})), document.addEventListener("DOMContentLoaded", (function() {
    if (document.querySelector(".product-hp")) {
        printSizeGrids(document.querySelector('[id^="ProductInfo-"]'))
    }
}));
const charts = {
  women: [
    { uk: "2", eu: "34", us: "4.5", cm: "21.2" },
    { uk: "2.5", eu: "35", us: "5", cm: "21.6" },
    { uk: "3", eu: "35.5", us: "5.5", cm: "22.1" },
    { uk: "3.5", eu: "36", us: "6", cm: "22.5" },
    { uk: "4", eu: "37", us: "6.5", cm: "22.9" },
    { uk: "4.5", eu: "37.5", us: "7", cm: "23.3" },
    { uk: "5", eu: "38", us: "7.5", cm: "23.7" },
    { uk: "5.5", eu: "39", us: "8", cm: "24.1" },
    { uk: "6", eu: "39.5", us: "8.5", cm: "24.6" },
    { uk: "6.5", eu: "40", us: "9", cm: "25" },
    { uk: "7", eu: "41", us: "9.5", cm: "25.4" },
    { uk: "7.5", eu: "41.5", us: "10", cm: "25.8" },
    { uk: "8", eu: "42", us: "10.5", cm: "26.3" },
    { uk: "8.5", eu: "42.5", us: "11", cm: "26.7" },
    { uk: "9", eu: "43", us: "11.5", cm: "27.2" }
  ],
  men: [
    { uk: "6", eu: "39.5", us: "7", cm: "24.6" },
    { uk: "6.5", eu: "40", us: "7.5", cm: "25" },
    { uk: "7", eu: "41", us: "8", cm: "25.4" },
    { uk: "7.5", eu: "41.5", us: "8.5", cm: "25.8" },
    { uk: "8", eu: "42", us: "9", cm: "26.3" },
    { uk: "8.5", eu: "42.5", us: "9.5", cm: "26.7" },
    { uk: "9", eu: "43", us: "10", cm: "27.2" },
    { uk: "9.5", eu: "44", us: "10.5", cm: "27.6" },
    { uk: "10", eu: "44.45", us: "11", cm: "28" },
    { uk: "10.5", eu: "45", us: "11.5", cm: "28.5" },
    { uk: "11", eu: "46", us: "12", cm: "28.9" },
    { uk: "11.5", eu: "46.5", us: "12.5", cm: "29.3" },
    { uk: "12", eu: "47", us: "13", cm: "29.8" },
    { uk: "12.5", eu: "47.5", us: "13.5", cm: "30.2" },
    { uk: "13", eu: "48", us: "14", cm: "30.6" },
    { uk: "13.5", eu: "49", us: "14.5", cm: "31.2" }
  ],
  kids: [
    { uk: "02", eu: "17.5", us: "02.5", cm: "9.9" },
    { uk: "02.5", eu: "18", us: "03", cm: "10.4" },
    { uk: "03", eu: "18.5", us: "03.5", cm: "10.9" },
    { uk: "03.5", eu: "19", us: "04", cm: "11.4" },
    { uk: "04", eu: "20", us: "04.5", cm: "11.9" },
    { uk: "04.5", eu: "20.5", us: "05", cm: "12.3" },
    { uk: "05", eu: "21", us: "05.5", cm: "12.7" },
    { uk: "05.5", eu: "22", us: "06", cm: "13.1" },
    { uk: "06", eu: "22.5", us: "06.5", cm: "13.5" },
    { uk: "06.5", eu: "23", us: "07", cm: "14" },
    { uk: "07", eu: "24", us: "07.5", cm: "14.4" },
    { uk: "07.5", eu: "25", us: "08", cm: "14.8" },
    { uk: "08", eu: "25.5", us: "08.5", cm: "15.2" },
    { uk: "08.5", eu: "26", us: "09", cm: "15.7" },
    { uk: "09", eu: "27", us: "09.5", cm: "16.1" },
    { uk: "09.5", eu: "27.5", us: "010", cm: "16.5" },
    { uk: "010", eu: "28", us: "010.5", cm: "16.9" },
    { uk: "010.5", eu: "28.5", us: "011", cm: "17.4" },
    { uk: "011", eu: "29", us: "011.5", cm: "17.8" },
    { uk: "011.5", eu: "29.5", us: "012", cm: "18.2" },
    { uk: "012", eu: "30", us: "012.5", cm: "18.6" },
    { uk: "012.5", eu: "31", us: "013", cm: "19" },
    { uk: "0", eu: "32", us: "013.5", cm: "19.5" },
    { uk: "013", eu: "32", us: "013.5", cm: "19.5" },
    { uk: "013.5", eu: "32.5", us: "1", cm: "19.9" },
    { uk: "1", eu: "33", us: "1.5", cm: "20.3" },
    { uk: "1.5", eu: "33.5", us: "2", cm: "20.7" },
    { uk: "2", eu: "34", us: "2.5", cm: "21.2" },
    { uk: "2.5", eu: "35", us: "3", cm: "21.6" },
    { uk: "3", eu: "35.5", us: "3.5", cm: "22" },
    { uk: "3.5", eu: "36", us: "4", cm: "22.4" },
    { uk: "4", eu: "37", us: "5", cm: "22.9" },
    { uk: "4.5", eu: "37.5", us: "5.5", cm: "23.3" },
    { uk: "5", eu: "38", us: "6", cm: "23.7" },
    { uk: "5.5", eu: "39", us: "6.5", cm: "24.2" },
    { uk: "6", eu: "39.5", us: "7", cm: "24.6" },
    { uk: "6.5", eu: "40", us: "7.5", cm: "25" },
    { uk: "7", eu: "41", us: "8", cm: "25.4" },
    { uk: "7.5", eu: "41.5", us: "8.5", cm: "25.8" },
    { uk: "8", eu: "42", us: "9", cm: "26.2" },
    { uk: "8.5", eu: "42.5", us: "9.5", cm: "26.7" },
    { uk: "9", eu: "43", us: "10", cm: "27.1" },
    { uk: "9.5", eu: "44", us: "10.5", cm: "27.5" },
    { uk: "10", eu: "44.5", us: "11", cm: "27.9" },
    { uk: "10.5", eu: "45", us: "11.5", cm: "28.4" },
    { uk: "11", eu: "45.5", us: "12", cm: "28.8" },
    { uk: "11.5", eu: "46.5", us: "12.5", cm: "29.2" },
    { uk: "12", eu: "47", us: "13", cm: "29.6" },
    { uk: "12.5", eu: "47.5", us: "13.5", cm: "30.1" },
    { uk: "13", eu: "48.5", us: "14", cm: "30.5" },
    { uk: "13.5", eu: "49", us: "14.5", cm: "30.9" },
    { uk: "14", eu: "49.5", us: "15", cm: "31.3" }
  ]
};
function getcustomSizechart(gender) {
  const data = charts[gender?.toLowerCase()];
  if (!data) return [];

  return data.map(item => ({
    ...item
  }));
}
function setcustomSizecharthtml() {
  const sizeElement = document.querySelector('.universal-size-list-new');
  if (!sizeElement) return;

  const sizegender = sizeElement.getAttribute('data-gender');
  const gendercharts = getcustomSizechart(sizegender);

  const tbody = document.querySelector('.newsizechart table tbody');
  if (!tbody) return;

  // Clear old rows
  tbody.innerHTML = '';

  const rows = gendercharts.map(size => `
    <tr class="size-guide__row">
      <td class="size-guide__row--data">${size.us}</td>
      <td class="size-guide__row--data">${size.uk}</td>
      <td class="size-guide__row--data">${size.eu}</td>
      <td class="size-guide__row--data">${size.cm}</td>
    </tr>
  `).join('');

  tbody.insertAdjacentHTML('beforeend', rows);
}
function getcustomSize(size, fromType, gender, toType) {

  const chart = charts[gender.toLowerCase()];
  if (!chart) return null;

  size = String(size);
  let row = null;

  // Find row based on input type
  if (fromType === "UK") {
    row = chart.find(r => String(r.uk) === size);
  } else if (fromType === "EU") {
    row = chart.find(r => String(r.eu) === size);
  } else if (fromType === "US") {
    row = chart.find(r => String(r.us) === size);
  }

  if (!row) return null;
//console.log(row);
  // Return requested type directly (no conversion)
  if (toType === "UK") return row.uk;
  if (toType === "EU") return row.eu;
  if (toType === "US") return row.us;
  if (toType === "CM") return row.cm;

  return null;
}

document.querySelectorAll('.universal-size-list-new .size-option').forEach(option => {

    option.addEventListener('click', function () {

        document.querySelectorAll('.universal-size-list-new .size-option').forEach(el => el.classList.remove('selected'));
        this.classList.add('selected');

        const convertTo = this.getAttribute('data-size');
        const parentList = this.closest('.universal-size-list-new');
        const sizeGender = parentList.getAttribute('data-gender');

        const productForm = this.closest('.product-form__input');
        productForm.querySelectorAll('label.product-form__size-label').forEach(label => {

            const sizeValue = (label.getAttribute('data-value'));
            //console.log(sizeValue, window.defaultsizeformat, sizeGender,convertTo);

            const sizeData = getcustomSize(sizeValue, window.defaultsizeformat, sizeGender,convertTo);
            if (sizeData !== null) {
              let sizeHtml = `<span>${convertTo}</span>`;
              sizeHtml += `<span>${sizeData}</span>`;
              label.innerHTML = sizeHtml;
            }
        });
        updatesizeinproperties();
    });
});
setcustomSizecharthtml();
function updatesizeinproperties() {
    const atcform = document.querySelector('.product__info-container product-form form');
    const selectedsizeRadio = document.querySelector('.option_name_size input[type="radio"]:checked');
    if (!atcform || !selectedsizeRadio) return;

    const label = document.querySelector(`label[for="${selectedsizeRadio.id}"]`);
    let selectedsizetext = label?.textContent.trim() || '';

    const selectedsizetype = document.querySelector('.universal-size-list-new .size-option.selected') ?.dataset.size || '';
    if (selectedsizetype) {
        selectedsizetext = selectedsizetext.replace(new RegExp(`^${selectedsizetype}\\s*`, 'i'), '').trim();
    }

    const finalSize = `${selectedsizetype} ${selectedsizetext}`.trim();
    if (!finalSize) return;

    let sizeInput = atcform.querySelector('input[name="properties[Size]"]');
    if (sizeInput) {
        sizeInput.value = finalSize;
    } else {
        sizeInput = document.createElement('input');
        sizeInput.type = 'hidden';
        sizeInput.name = 'properties[Size]';
        sizeInput.value = finalSize;
        atcform.appendChild(sizeInput);
    }
}
if(document.querySelector('.universal-size-list-new')){
  document.addEventListener('change', function(event) {
      if (event.target.matches('input[name="id"]')) {
        updatesizeinproperties();
      }
  });
}

